import { useStaticQuery, graphql } from 'gatsby';

/* eslint-disable import/prefer-default-export */
export const useSiteMetadata = () => {
  const { site } = useStaticQuery(
    graphql`
      query SiteMetaData {
        site {
          siteMetadata {
            baseUrl
          }
        }
      }
    `
  );
  return site.siteMetadata;
};
